import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import axios from "axios";
import {toast} from "react-toastify";

const ArchiveJobSurveyModal = (props) => {
    const {
        show        = false,
        parentId    = "",
        disabled    = false,
        onCancel    = () => { },
        onComplete  = (survey) => { },
        jobId       = null,
        surveyId    = null,
        id          = "archive-job-survey-modal",
    } = props;

    const [submitting, setSubmitting]   = useState(false);
    const [job, setJob]                 = useState(null);
    const [survey, setSurvey]           = useState(null);

    useEffect(() => {
        if (!!jobId && !!surveyId) {
            load();
        }
    }, [jobId, surveyId]);

    const load = () => {
        axios.get(route('web-api.job.survey.config', {job: jobId, survey_id: surveyId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.job) {
                        setJob(response.data.job);
                    }

                    if (!!response.data.survey) {
                        setSurvey(response.data.survey);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const submit = () => {
        axios.delete(route('web-api.job.survey.destroy', {
            job:    jobId,
            survey: surveyId,
        }).toString())
            .then((response) => {
                setSubmitting(false);
                onComplete(survey);
            })
            .catch((error) => {
                console.log(error);
                setSubmitting(false);
            });
    }

    const handleClose = () => {
        onCancel();
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            parentSelector={() => document.getElementById(parentId)}
            onRequestClose={() => handleClose()}
            contentLabel="Delete Survey"
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h5 className="modal-title text-eh-navy">Delete Survey</h5>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleClose()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <p className="mb-3">
                        Are you sure you want to <b className="text-danger">delete</b> this survey:
                    </p>
                    {!!job && (
                        <React.Fragment>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Job Name</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!job.name ? job.name : "-"}</p>
                            </div>
                        </React.Fragment>
                    )}
                    {!!survey && (
                        <React.Fragment>
                            <div>
                                <p className="mb-0 text-eh-off-black"><strong>Survey Admin Notes</strong></p>
                                <p className="mb-1 text-eh-off-black">{!!survey.admin_notes ? survey.admin_notes : "-"}</p>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className="modal-footer m-0 p-0 d-flex justify-content-start align-items-center border-0">
                    <button
                        type="submit"
                        className="btn btn-danger py-0 px-3 ml-0 py-0 mr-4"
                        onClick={() => setSubmitting(true)}
                        disabled={submitting || disabled}
                    >
                        {"Yes, Delete Survey"}
                    </button>
                    <button
                        type="button" data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-0"
                        onClick={() => handleClose()}
                    >
                        {"Cancel"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ArchiveJobSurveyModal;
